module.exports = __webpack_public_path__ + "static/media/new-quick-signal-video.80bbcd05.svg";